<template>
  <div id="stations" class="p-4">
    <div class="row">
      <div class="col-6">
        <div class="card w-100">
          <div class="card-header py-3">
            <div class="row justify-content-between">
              <div class="col-6">
                <div class="pt-2 font-bold text-uppercase">Stations</div>
              </div>
              <div class="col-6">

              </div>
            </div>
          </div>
          <div class="card-body p-0">
            <button class="btn btn-create my-2 ml-4" @click="onCreateStation">+ Add Station</button>
            <ul class="list-group list-group-flush">
              <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center cursor-pointer"
                  v-for="station of getStations" :key="station.id"
                  @click="onSelectStation($event, station)">
                <span class="station-name"><b>{{ station.number }}</b> - {{ station.name }}</span>
                <span class="cursor-pointer" @click="onEditStation(station)">
                  <img src="../assets/img/edit-icon.png">
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card w-100">
          <div class="card-header py-3">
            <div class="pt-2 font-bold text-uppercase">Platforms</div>
          </div>
          <div class="card-body p-0">
            <button class="btn btn-create my-2 ml-4" @click="onCreatePlatform" v-if="getStation.id">+ Add Platform</button>
            <ul class="list-group list-group-flush" v-if="getStation.id">
              <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center cursor-pointer"
                  v-for="platform of getStation.platforms" :key="platform.id">
                <span>{{ platform.name }}</span>
                <span class="cursor-pointer" @click="onEditPlatform(platform)">
                  <img src="../assets/img/edit-icon.png">
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex'

  export default {
    name: 'Stations',
    computed: {
      ...mapGetters([
        'getStations',
        'getStation',
      ])
    },
    mounted() {
      this.queryStations()
    },
    methods: {
      ...mapActions([
        'queryStations',
        'showModal',
      ]),
      ...mapMutations([
        'setStation',
        'setStationsFilters',
      ]),
      onSelectStation(event, station) {
        if (event.target.tagName === 'LI' || event.target.className === 'station-name')
          this.setStation(station)
      },
      onCreateStation() {
        this.showModal({modal: 'ModalStation', data: {}})
      },
      onEditStation(station) {
        this.showModal({modal: 'ModalStation', data: station})
      },
      onCreatePlatform() {
        this.showModal({modal: 'ModalPlatform', data: {station_id: this.getStation.id}})
      },
      onEditPlatform(platform) {
        this.showModal({modal: 'ModalPlatform', data: platform})
      }
    }
  }
</script>

<style scoped>

</style>
